import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { DOMAIN_ACTION_TYPES } from './constants';
import translations from '../../../common/constants/translations';
import { validateDomain } from '../../../utils/common-utils';

import DomainManagementBulkActionBar from './domain-management-bulk-action-bar';
import DomainManagementBulkContent from './domain-management-bulk-content';
import DomainManagementBulkLoading from './domain-management-bulk-loading';

// Order matters here. Sending is first for choosing a a domain type
// eslint-disable-next-line sort-keys
const DOMAIN_TYPES = { sending: translations.sending, nonsending: translations.nonsending, };

const styles = ( theme => ( {
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    contentHeader: {
        margin: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`
    },
} ) );

class DomainManagementBulk extends Component{
    constructor( props ){
        super( props );

        this.state = {
            disableSave: true,
            domainActionType: props.domainActionType || Object.keys( DOMAIN_ACTION_TYPES )[0],
            domainList: '',
            domainListErrorMessage: '',
            domainTypeSelected: Object.keys( DOMAIN_TYPES )[0],
            filteredDomainList: [],
            invalidDomains: [],
        };
    }

    onChangeDomainActionType = ( event ) => {
        this.setState( { domainActionType: event.target.value } );
    }

    onChangeDomainType = ( event ) => {
        this.setState( { domainTypeSelected: event.target.value } );
    }

    onChangeDomainList = ( event ) => {
        this.filterDomainList( event.target.value );
    }

    submitDomains = () => {
        const { filteredDomainList, domainActionType, domainTypeSelected, domainList } = this.state;

        const trimmedDomainList = domainList.trim();

        if( trimmedDomainList === '' ){
            this.setState( { domainListErrorMessage: 'Please enter in a list of domains' } );
        }
        else{
            const { addDomains, changeDomainType, removeDomains } = this.props;
            switch( domainActionType ){
                case 'changeType':
                    changeDomainType( filteredDomainList, domainTypeSelected );
                    break;
                case 'remove':
                    removeDomains( filteredDomainList );
                    break;
                default:
                case 'add':
                    addDomains( filteredDomainList, domainTypeSelected );
                    break;
            }
        }
    }

    filterDomainList = ( value = '' ) => {
        const filteredDomainList = [];
        const invalidDomains = [];
        let errorMessage = '';

        value.replace( /\n/g, ',' ).split( ',' )
            .filter( domain => domain !== '' )
            .forEach( domain => {
                const trimmedDomain = domain.trim();
                if( !validateDomain( trimmedDomain ) ){
                    invalidDomains.push( trimmedDomain );
                    errorMessage = `Invalid Domains: ${invalidDomains.join( ', ' )}`;
                }
                else{
                    filteredDomainList.push( trimmedDomain );
                }
            } );


        this.setState( {
            disableSave: invalidDomains.length > 0 || !value.length,
            domainList: value,
            domainListErrorMessage: errorMessage,
            filteredDomainList,
            invalidDomains,
        } );
    }

    render(){
        const { classes, closeRightPane, domainErrors, isLoading } = this.props;
        const { domainList, domainListErrorMessage, domainActionType, domainTypeSelected } = this.state;

        return (
            <div className={classes.container}>
                {
                    isLoading ?
                        <DomainManagementBulkLoading domainActionType={domainActionType} /> : (
                            <React.Fragment>
                                <DomainManagementBulkContent
                                    domainList={domainList}
                                    domainListErrorMessage={domainListErrorMessage}
                                    domainActionType={domainActionType}
                                    domainTypeSelected={domainTypeSelected}
                                    onChangeDomainActionType={this.onChangeDomainActionType}
                                    onChangeDomainList={this.onChangeDomainList}
                                    onChangeDomainType={this.onChangeDomainType}
                                    domainErrors={domainErrors}
                                />
                            </React.Fragment>
                        )}
                <DomainManagementBulkActionBar
                    isLoading={isLoading}
                    onClickCancel={closeRightPane}
                    onClickSave={this.submitDomains}
                    disableSaveButton={this.state.disableSave}
                    domainErrors={domainErrors}
                />
            </div>
        );
    }
}

DomainManagementBulk.propTypes = {
    addDomains: PropTypes.func.isRequired,
    changeDomainType: PropTypes.func.isRequired,
    classes: PropTypes.object,
    closeRightPane: PropTypes.func.isRequired,
    domainActionType: PropTypes.string,
    domainErrors: PropTypes.object,
    isLoading: PropTypes.bool,
    removeDomains: PropTypes.func.isRequired,
};

export default withStyles( styles )( DomainManagementBulk );
